import React, { useEffect, useState } from 'react';
import {
  FaseGrupoPartidasLite,
  buscarFaseGrupoPartidasPorFaseCategoriaTorneio,
  deletarFaseGrupoPartidas,
} from '../../services/faseGrupoPartidasService';
import { Local } from '../../types/local';
import FaseGrupoEquipesCard from '../admin/category/FaseGrupoEquipesCard';
import FaseGrupoModal from './FaseGrupoModal';

export type FaseCategoriaTorneioLite = {
  id: string;
  nome: string;
};

export type ListGroupMatchesProps = {
  faseCategoriaTorneio: FaseCategoriaTorneioLite;
  categoriaTorneioId: string;
  localTorneio: Local;
  categoriaTorneio?: {
    gamesPorSets?: number | null;
    tiebreaks?: number | null;
    numeroSets?: number | null;
  } | null;
};

const ListGroupMatches: React.FC<ListGroupMatchesProps> = ({ faseCategoriaTorneio, categoriaTorneioId, localTorneio, categoriaTorneio }) => {
  const [fasesGrupoPartidas, setFasesGrupoPartidas] = useState<FaseGrupoPartidasLite[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState<FaseGrupoPartidasLite | null>(null);

  const load = async () => {
    const data = await buscarFaseGrupoPartidasPorFaseCategoriaTorneio(
      faseCategoriaTorneio.id,
    );
    setFasesGrupoPartidas(data);
  };

  useEffect(() => {
    load();
  }, [faseCategoriaTorneio.id]);

  const handleNovoGrupo = () => {
    setEditing(null);
    setModalOpen(true);
  };

  const handleEditarGrupo = (faseId: string) => {
    const fase = fasesGrupoPartidas.find(f => f.id === faseId) || null;
    setEditing(fase);
    setModalOpen(true);
  };

  const handleDeletarGrupo = async (faseId: string) => {
    if (!window.confirm('Deseja excluir este grupo?')) return;
    await deletarFaseGrupoPartidas(faseId);
    await load();
  };

  return (
    <div data-testid="list-group-matches-root" className="d-flex flex-column gap-3">
      <div className="d-flex justify-content-between align-items-center">
        <h3 data-testid="list-group-matches-title" aria-label="Nome da FaseCategoriaTorneio">
          {faseCategoriaTorneio.nome}
        </h3>
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={handleNovoGrupo}
          aria-label="Novo Grupo"
          data-testid="btn-novo-grupo"
        >
          Novo Grupo +
        </button>
      </div>
      <div className='row d-flex justify-content-start'>
        {fasesGrupoPartidas.length === 0 ? (
          <div className='col-12' data-testid="list-group-matches-empty">Nenhum grupo cadastrado nessa fase</div>
        ) : (
          fasesGrupoPartidas.map(fase => (
            <div key={fase.id} data-testid={`list-group-matches-item-${fase.id}`} className="mb-4 col-12 col-md-6">
              <FaseGrupoEquipesCard
                fase={{ id: fase.id, nome: fase.nome }}
                faseCategoriaTorneioId={faseCategoriaTorneio.id}
                categoriaTorneioId={categoriaTorneioId}
                onEdit={handleEditarGrupo}
                onDelete={handleDeletarGrupo}
              />
            </div>
          ))
        )}

      </div>
      <FaseGrupoModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        faseCategoriaTorneioId={faseCategoriaTorneio.id}
        faseGrupoPartidas={editing}
        categoriaTorneioId={categoriaTorneioId}
        localTorneio={localTorneio}
        categoriaTorneio={categoriaTorneio}
        onSaved={load}
      />
    </div>
  );
};

export default ListGroupMatches;


